import { render, staticRenderFns } from "./ModalCompanyCompany.vue?vue&type=template&id=19b00b2a"
import script from "./ModalCompanyCompany.vue?vue&type=script&lang=js"
export * from "./ModalCompanyCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports